<template>
  <div>
     <van-search shape="round" placeholder="搜索" v-model="searchTxt"  @search="fetchRightStudentList"/>
     <div style="padding:15px 20px;background:#fff;">
       {{xy.moment(obj.ClassDate).format('YYYY-MM-DD') + " " +obj.DisciplineName + "第"+ obj.AMorPMOrder +"节"}}
     </div>
     <div class="select-all"> 
        <van-checkbox v-model="checkedAll" @click="selectedAll">全选</van-checkbox>
      </div>
     <div style="margin-bottom: 100px;">
        <ul class="list" v-show="dataTable.length > 0">
          <li
            class="student"
            v-for="(item, index) in dataTable"
            :key="index"
          >
            <van-checkbox v-model="item._checked"  @click="ischeck">
              <span class="head" v-if="item.Icon"><img :src="item.Icon"></span>
              <span class="head" v-else>{{xy.showName(item.FullName)}}</span>
              <!-- <Avatar :iconPath="item.Icon?$store.state.apiPath + item.Icon:item.Icon" :fullName="item.FullName" class="avatar"></Avatar> -->
              <div class="name">
                <div>
                  <p class="fullName">{{ item.FullName }}</p>
                  <p class="UserName">{{item.UserName}}</p>
                </div>
                <span class="person">{{item.TotalScore}} 分</span>
              </div>
            </van-checkbox>
          </li>
        </ul>
     </div>
      <div class="footer">
        <div class="alerdy">已选{{pickedArr.length}}/{{dataTable.length}}人</div>
        <div class="btn" @click="save">保存</div>
      </div>
  </div>
</template>
<script>
// import Avatar from '@/pages/attendance/components/Avatar.vue'
export default {
  components: {
    // Avatar
  },
  data() {
    return {
      searchTxt:'',
      dataTable:[],
      choicePerson:[],
      checkedAll:false,
      pickedArr:[],
      obj:{}
    }
  },
  created(){
    this.obj = this.$store.state.evaluation.averageObj
    this.fetchRightStudentList()
  },
  methods:{
    // 全选
    selectedAll(){
      this.pickedArr=[]
      this.dataTable.forEach(item=>{
        item._checked = this.checkedAll
        if(this.checkedAll){
          this.pickedArr.push(item.UserID)
        }else{
          this.pickedArr=[]
        }
      })
    },
    // 选中指标
    ischeck(){
      this.pickedArr=[]
      this.dataTable.forEach(item=>{
        if(item._checked){
          this.pickedArr.push(item.UserID)
        }
      })
      if(this.pickedArr.length===this.dataTable.length){
        this.checkedAll=true
      }else{
        this.checkedAll=false
      }
    },
    // 获取学生列表
    async fetchRightStudentList () {
      let params = {
        coursePlanAID: this.obj.CoursePlanAID,
        classTableGenerateBaseID: this.obj.ClassTableGenerateBaseID,
        coursePlanAIDType: this.obj.CoursePlanAIDType,
        studentOrganizationID: this.obj.StudentOrganizationID,
        name:this.searchTxt
      }
      this.xy.loading()
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/EvaluateStudent/GetStudentScoreList`, params)
      this.xy.unloading()
      if (res.success) {
        this.dataTable = []
        if (res.data.length > 0) {
          this.dataTable = res.data
          console.log("学生",this.dataTable)
        }
      }
    },
    async save(){
      let params = {
        ClassTableGenerateBaseID: this.obj.ClassTableGenerateBaseID,
        DisciplineID: this.obj.DisciplineID,
        CoursePlanAID: this.obj.CoursePlanAID,
        CoursePlanAIDType: this.obj.CoursePlanAIDType,
        Scores: this.$route.query.Scores,
        UserID: this.pickedArr
      }
      this.xy.loading()
      let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/EvaluateStudent/UpdataStudentScore`, params, true)
      this.xy.unloading()
      if (res.success) {
        this.xy.msgSuc(res.msg || '保存成功！');
        setTimeout(() => {
          this.$router.push({ path: '/home/evaStudent'});
        }, 1000);
      }else{
        this.xy.msgError(res.msg || '保存失败！');
      }
    }
  }
}
</script>  
<style lang="less" scoped>
.head {
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    text-align: left;
    border-radius: 50%;
    background: @blue;
    font-size: 30px;
    color: #fff;
    > img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 50%;
    }
  }
// 颜色方案定义
@color-main-bg: #4196ff;
@color-main-text: #fff;
@color-primary-bg: #4196ff;
@color-primary-text: #fff;
@color-normal-bg: #e9e9e9;
@color-normal-text: #161616;
.select-all{
  margin-top:16px;
  margin-bottom:16px;
  height:100px;
  background: #fff;
  padding:30px 32px;
}
.list{
  padding:32px;
  background: #fff;
  padding-bottom:100px;
  li{
    height: 100px;
    line-height: 100px;
    .UserName{
      color:#ABABB0;
    }
    .person{
      color: #7E7E7E;
    }
    /deep/ .van-checkbox__icon{
      margin-bottom: 10px;
    }
    /deep/ .van-checkbox__label{
      flex:1;
      display: flex;
      border-bottom:1px solid #EFEFEF;
      padding-bottom: 10px;
    }
    .name{
      flex:1;
      display: flex;
      margin-left:20px;
      justify-content: space-between;
      align-items: flex-end;
    }
  }
  li:last-child{
    /deep/ .van-checkbox__label{
      // border:none;
    }
  }
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index: 15;
  bottom: 0;
  width: 100%;
  height: 110px;
  text-align: center;
  padding: 17px 32px;
  background: #fff;
  .btn {
    margin: 0 10px;
  }
  .alerdy{
    color:#4196FF;
  }
}
.btn {
  display: inline-block;
  line-height: 76px;
  min-width: 270px;
  text-align: center;
  padding: 0 20px;
  background: @color-main-bg;
  color: @color-main-text;
  border: 1px solid @color-main-bg;
  border-radius: 38px;
  &.plain {
    background: #fff;
    color: @color-main-bg;
    border: 1px solid;
  }
  &.small {
    min-width: 126px;
    line-height: 52px;
    border-radius: 26px;
  }
}
</style>